<template>
    <div class="occupy-space" :style="{ height: height }"></div>
</template>

<script setup lang="ts">
defineProps<{
    height: string
}>()
</script>

<style scoped lang="scss">
.occupy-space {
    // background-color: #01031B;
}
</style>